import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ReceiptsDTO } from './dto/receipts.dto';
import { ReceiptsService } from './receipts.service';
@ApiTags('Receipts')
@Controller('Receipts')
export class ReceiptsController {
    constructor(private receiptsService:ReceiptsService){}
    @Post('/saveReceipt')
    async saveReceipt(@Body() receiptsRequest: ReceiptsDTO,@Req() request: Request): Promise<any> {
    //   console.log(receiptsRequest);
      try {
        return await this.receiptsService.saveReceipt(receiptsRequest);
      } catch (error) {
        // throw new LoansResponseModel(false,11104, 'Something wrong');
      }
    }
    
}
